import { Component, OnInit } from '@angular/core';
import { CadastroService } from 'src/app/services/cadastro.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-dados-pessoais',
    templateUrl: './dados-pessoais.component.html',
    styleUrls: ['./dados-pessoais.component.css'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class DadosPessoaisComponent implements OnInit {

  listaEstadoCivil:any[] = [];
  sexos: any[] = [];
  form: FormGroup = null;

  loading: boolean = false;
  msgErro: string = null;

  nomeConjuge: boolean = false;

  constructor(private cadastro: CadastroService, private toastr: ToastrService, private http: HttpClient) { 

    this.form = new FormGroup({
      nome:new FormControl(null,[Validators.required]),
      nomeSocial:new FormControl(null,[]),
      estadoCivil: new FormControl(null,[Validators.required]),
      rg: new FormControl(null,[Validators.required]),
      orgExpeditor: new FormControl(null,[Validators.required]),
      ocupacao: new FormControl(null,[Validators.required]),
      codSexo: new FormControl(null,[Validators.required]),
      dtaNasc: new FormControl(null,[Validators.required]),
      nomeMae: new FormControl(null,[Validators.required]),
      nomePai: new FormControl(null,[Validators.required]),
      naturalidade: new FormControl(null,[Validators.required]),
      nomeConjuge: new FormControl(null,[Validators.required]),
      dtaExpedicao: new FormControl(null,[Validators.required]),
      assinatura: new FormControl(null,[Validators.required])
    });
  }

  ngOnInit() {
    this.buscaEstadiCivil();
    this.listarSexos();
  }

  buscaEstadiCivil(){
    this.cadastro
    .listaEstadoCivil()
    .subscribe(
      (res:any)=>{
        this.listaEstadoCivil = res;
      }
    )
  }

  
  listarSexos(){

    this.cadastro
    .listaSexos()
    .subscribe(
      (res:any)=>{
        this.sexos = res;
      }
    )

  }

  buscaDadosPessoais(){
    this.cadastro
    .buscaDadosPessoais()
    .subscribe(
      (res:any)=>{

        this.form.get("nome").setValue(res.NOME)
        this.form.get("nomeSocial").setValue(res.NOME_SOCIAL)
        this.form.get("estadoCivil").setValue(res.COD_ESTADO_CIVIL)
        this.form.get("rg").setValue(res.DCR_RG_IDENT)
        this.form.get("orgExpeditor").setValue(res.DCR_ORGEXP_IDENT)
        this.form.get("ocupacao").setValue(res.DCR_OCUP_PROF)
        this.form.get("codSexo").setValue(res.COD_SEXO)
        this.form.get("dtaNasc").setValue(Intl.DateTimeFormat('pt-BR').format(new Date(res.DTA_NASC)))
        this.form.get("nomeMae").setValue(res.NOM_MAE)
        this.form.get("nomePai").setValue(res.NOM_PAI)
        this.form.get("naturalidade").setValue(res.DCR_NATURALIDADE)
        this.form.get("nomeConjuge").setValue(res.NOM_CONJUGE)
        this.form.get("dtaExpedicao").setValue(Intl.DateTimeFormat('pt-BR').format(new Date(res.DTA_EXP_IDENT)))

        var anos = (new Date().getTime() - new Date(res.DTA_NASC.replace(/-/g, '\/')).getTime()) / (1000 * 60 * 60 * 24 * 365.25);

        if(anos<18){
          this.form.get("nomeConjuge").disable();
        }

        this.onChangeEstadoCivil(res.COD_ESTADO_CIVIL);

      },
      (error: HttpErrorResponse)=> {
        this.toastr.error(error.error.ex);
      }
    )
  }

  alterar(){

    this.loading = true;

    this.cadastro
    .dadosPessoaisAlterar(this.form.getRawValue())
    .pipe(
      finalize(() => { this.loading=false })
    )
    .subscribe(
      (res:any)=>{
        this.toastr.success("Alteração realizada com sucesso!")
        this.form.get("assinatura").setValue("");
      },
      (error: HttpErrorResponse)=> {
        this.msgErro = error.error.ex;

        setTimeout(()=>{
          this.msgErro = null;
        }, 5000);
      }
    )
  }

  onChangeEstadoCivil(cod){

    if(cod==1 || cod==4 || cod==7){
      this.nomeConjuge = true;
      this.form.get("nomeConjuge").enable();
    }else{
      this.nomeConjuge = false;
      this.form.get("nomeConjuge").setValue("");
      this.form.get("nomeConjuge").disable();
    }

  }

  apenasLetras(event: any) {
    event.target.value = event.target.value.replace(/[&\/\\#,+()$%.'":*?<>{}\[\]\=\-\;0-9]/g, "");
  }

  apenasNumeros(event: any) {
    event.target.value = event.target.value.replace(/\D/g, "");
  }
}
